import { useEffect, useState } from 'react';
import { getAllSustainabilityDocuments } from '../helpers/transparencyCatalogHelper';
import { ActionResponse } from '../models/actionResponse/types';
import { getLeedDocumentTypesAction, getLeedLEMDocumentTypesAction } from '../redux/actions/productActions';
import { LeedDocumentType, SustainabilityDocument } from '../redux/actions/productActions/types';
import { useAppDispatch, useAppSelector } from './redux';

// Document-type reference data needed by the product upload components (ProductUploads).
export const useUploadDocumentTypes = () => {
    const dispatch = useAppDispatch();
    const [sustainabilityDocuments, setSustainabilityDocuments] = useState<SustainabilityDocument[]>([]);
    const [leedDocumentTypes, setLeedDocumentTypes] = useState<LeedDocumentType[]>([]);
    const [leedLEMDocumentTypes, setLeedLEMDocumentTypes] = useState<LeedDocumentType[]>([]);

    // Get cached LEED document types from Redux
    const cachedLeedDocumentTypes = useAppSelector((state) => state.productReducer.leedDocumentTypes);
    const cachedLeedLemDocumentTypes = useAppSelector((state) => state.productReducer.leedLemDocumentTypes);

    const fetchLemDocuments = async () => {
        // Use cached data if available, otherwise fetch
        if (cachedLeedLemDocumentTypes) {
            setLeedLEMDocumentTypes(cachedLeedLemDocumentTypes);
        } else {
            const leedDocs = (await dispatch(getLeedLEMDocumentTypesAction() as any)) as ActionResponse<LeedDocumentType[]>;
            setLeedLEMDocumentTypes(leedDocs.payload.data || []);
        }
    };

    const fetchDocuments = async () => {
        const docs = await getAllSustainabilityDocuments(dispatch);
        setSustainabilityDocuments(docs || []);

        // Use cached data if available, otherwise fetch
        if (cachedLeedDocumentTypes) {
            setLeedDocumentTypes(cachedLeedDocumentTypes);
        } else {
            const leedDocs = (await dispatch(getLeedDocumentTypesAction() as any)) as ActionResponse<LeedDocumentType[]>;
            setLeedDocumentTypes(leedDocs.payload.data || []);
        }
    };

    useEffect(() => {
        fetchDocuments();
    }, [cachedLeedDocumentTypes]);

    useEffect(() => {
        fetchLemDocuments();
    }, [cachedLeedLemDocumentTypes]);

    return { sustainabilityDocuments, leedDocumentTypes, leedLEMDocumentTypes };
};
